"use strict";

REATOA.pageScript = REATOA.pageScript || {
  init: {}
};
REATOA.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    console.log('product.js');
    initProductSlider();
  }
  function initProductSlider() {
    var length = $('.js-productThumbnail').length;
    var indicatorCurrent = document.querySelector('.js-productSliderIndicatorCurrent');
    var indicatorTotal = document.querySelector('.js-productSliderIndicatorTotal');
    indicatorTotal.textContent = length;
    indicatorCurrent.textContent = 1;
    var productThumbnailsSlider = new Swiper('.js-productThumbnailsSlider', {
      loop: false,
      effect: 'slide',
      slidesPerView: 3.2,
      breakpoints: {
        1024: {
          direction: 'vertical',
          slidesPerView: 6,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true
          }
        }
      }
    });
    var productMainSlider = new Swiper('.js-productMainSlider', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loopedSlides: 1,
      thumbs: {
        swiper: productThumbnailsSlider
      },
      navigation: {
        nextEl: '.js-productSliderControlsNext',
        prevEl: '.js-productSliderControlsPrev'
      },
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true
      }
    });
    productMainSlider.on('slideChange', function () {
      indicatorCurrent.textContent = productMainSlider.realIndex + 1;
    });
  }
  return {
    init: init
  };
}();
REATOA.common.init(REATOA.pageScript.init);